import React from 'react';
import { urlApi, storageUrl } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import { Col, Container, Row } from 'react-bootstrap';

const Client = ({ contents }) => {
  console.log("Client", contents);

  return (
    <>
      <SectionHeader topic='Representative Clients' detail={<span style={{ fontSize: '18px' }}></span>} bg={Bg} textSize={10} />
      <section className='pt-5 pb-5'>
        <Container className='pt-5 pb-5'>
          <Row>
            <Col xs={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }}>
              <Row>
                {contents?.web_setup?.client_logo.map((item, index) => (
                  <Col xs={4} md={3} key={index} className='px-4'>
                    <div className='position-relative ratio-1x1'>
                      <img src={`${storageUrl}/media/${item.set1}`} className='w-100 position-absolute top-50 translate-middle' />
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Client